namespace RedBullMOBILE360.CustomerCare {
    export interface LineTerminationReportForm {
        Msisdn: Serenity.StringEditor;
        IdNumber: Serenity.StringEditor;
        SellerId: Serenity.IntegerEditor;
        Otp: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        Status: Serenity.IntegerEditor;
        BssRequest: Serenity.StringEditor;
        BssResponse: Serenity.StringEditor;
        OrderLat: Serenity.StringEditor;
        OrderLng: Serenity.StringEditor;
        AgentId: Serenity.IntegerEditor;
    }

    export class LineTerminationReportForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.LineTerminationReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LineTerminationReportForm.init)  {
                LineTerminationReportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(LineTerminationReportForm, [
                    'Msisdn', w0,
                    'IdNumber', w0,
                    'SellerId', w1,
                    'Otp', w0,
                    'TransDate', w2,
                    'Status', w1,
                    'BssRequest', w0,
                    'BssResponse', w0,
                    'OrderLat', w0,
                    'OrderLng', w0,
                    'AgentId', w1
                ]);
            }
        }
    }
}
